import {
  ChargingSessionInAppNotificationAuthenticatePayload,
  ChargingSessionInAppNotificationPayload,
} from './categories/charging_session'
import { PaymentInAppNotificationPayload } from './categories/payment'

export enum InAppNotificationCategory {
  CHARGING_SESSION = 'charging_session',
  PAYMENT = 'payment',
}

export enum InAppNotificationUxPattern {
  INLINE = 'INLINE',
  TOAST = 'TOAST',
}

export enum InAppNotificationSeverity {
  CRITICAL = 'CRITICAL',
}

export type InAppNotificationData<TPayload extends Record<string, unknown>> = {
  data: {
    ux_pattern: InAppNotificationUxPattern
    title: string
    body: string
    event: string
    severity: InAppNotificationSeverity
    payload: TPayload
    type: 'IN_APP'
    category: InAppNotificationCategory
    server_time_now: string
  }
}

export type InAppNotificationCategoryDataMap = {
  [InAppNotificationCategory.CHARGING_SESSION]: InAppNotificationData<ChargingSessionInAppNotificationPayload>
  [InAppNotificationCategory.PAYMENT]: InAppNotificationData<PaymentInAppNotificationPayload>
}

export type InAppNotificationAuthenticatePayloadMap = {
  [InAppNotificationCategory.CHARGING_SESSION]: ChargingSessionInAppNotificationAuthenticatePayload
  [InAppNotificationCategory.PAYMENT]: unknown
}
